module.exports = __webpack_public_path__ + "assets/icons/ic_create-af11.svg";